import * as Yup from "yup";

export const validateModel = Yup.object().shape({
  phone: Yup.number().typeError("Debe ingresar solo números"),
  // .required("Campo obligatorio"),
  mobile: Yup.number().typeError("Debe ingresar solo números"),
  // .required("Campo obligatorio"),
});
